<template>
  <v-container fluid>
    <v-row no-gutters>
      <v-col cols="12" lg="6" sm="12">
        <v-card>
          <v-list-item>
            <v-list-item-avatar>
                <v-icon>mdi-message-bulleted</v-icon>
            </v-list-item-avatar>
            <v-list-item-content>
                <v-list-item-title class="headline">システムお知らせ情報登録</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-card-text>
            <v-form ref="system_notification_form" v-model="valid" @submit.prevent>
              <v-menu min-width="290px" max-width="290px">
                <template v-slot:activator="{ on }">
                  <v-text-field v-on="on" label="表示予定日" v-model="inputData.scheduledDisplayDate" dense outlined readonly @blur="scheduledDisplayDateCalendar = parseDate(inputData.scheduledDisplayDate)"/>
                </template>
                <v-date-picker v-model="scheduledDisplayDateCalendar" :min="today" no-title scrollable actions locale="ja-jp" :close-on-content-click="true" :day-format="date => new Date(date).getDate()"/>
              </v-menu>
              <v-menu min-width="290px" max-width="290px">
                <template v-slot:activator="{ on }">
                  <v-text-field v-on="on" label="表示期限日" v-model="inputData.displayPeriod" dense outlined readonly @blur="displayPeriodCalendar = parseDate(inputData.displayPeriod)"/>
                </template>
                <v-date-picker v-model="displayPeriodCalendar" :min="today" no-title scrollable actions locale="ja-jp" :close-on-content-click="true" :day-format="date => new Date(date).getDate()"/>
              </v-menu>
              <v-text-field v-model="inputData.title" label="タイトル" :rules="notificationTitleRules" dense outlined>
                <template v-slot:append>
                  <v-chip small color="red" text-color="white"><strong>必須</strong></v-chip>
                </template>
              </v-text-field>
              <v-textarea v-model="inputData.content" label="お知らせ内容" rows="5" :rules="notificationContentRules" counter="1500" outlined>
                <template v-slot:append>
                  <v-chip small color="red" text-color="white"><strong>必須</strong></v-chip>
                </template>
              </v-textarea>
            </v-form>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="grey lighten-1" class="mr-3" :to="{ name: 'SystemNotification' }" depressed>キャンセル</v-btn>
            <v-btn color="primary" @click.prevent="checkDialog" :disabled="!valid" depressed>確認</v-btn>
          </v-card-actions>
        </v-card>
      </v-col>
    </v-row>
    <v-row justify="center">
        <custom-dialog :maxWith="dialogMaxWith" :title="dialogTitle" :items="dialogItems" :drawer="dialogDrawer" visibleStore
          @stored="submit" @canceled="dialogCancel"/>
    </v-row>
  </v-container>
</template>

<script>
import { useAppInsights } from '@/plugins/application-insights';
import SystemNotificationsApi from "@/api/system-notifications-api";
import CustomDialog from "@/components/custom_ui/CustomDialog";
import Rule from "@/validation/rules";
import statusList from "@/helpers/const";

export default {
  name: "SystemNotificationcEntry",
  components: {
    CustomDialog
  },
  data: () => ({
    loading: false,

    // 登録ダイアログ
    dialogMaxWith: 500,
    dialogTitle: "",
    dialogItems: [],
    dialogDrawer: false,

    // バリデーション
    valid: true,
    notificationTitleRules: Rule.notificationTitleRules,
    notificationContentRules: Rule.notificationContentRules,

    // カレンダー
    scheduledDisplayDateCalendar: "",
    displayPeriodCalendar: "",

    //カレンダー:min
    today: new Date().toISOString().substr(0, 10),

    // お知らせ内容入力用バッファ
    inputData: {
      scheduledDisplayDate: "",
      displayPeriod: "",
      title: "",
      content: "",
      category: 1,
    },

  }),
  created() {
    this.initialize();
  },
  watch: {
    'scheduledDisplayDateCalendar': function(){
      if (this.displayPeriodCalendar < this.scheduledDisplayDateCalendar) {
          this.displayPeriodCalendar = this.scheduledDisplayDateCalendar;
      }
      this.inputData.scheduledDisplayDate = this.formatDate(this.scheduledDisplayDateCalendar);
    },
    'displayPeriodCalendar': function(){
      if (this.scheduledDisplayDateCalendar > this.displayPeriodCalendar) {
          this.scheduledDisplayDateCalendar = this.displayPeriodCalendar;
      }
      this.inputData.displayPeriod = this.formatDate(this.displayPeriodCalendar);
    }
  },
  methods: {
    isLoading() {
      this.loading = !this.loading;
      this.$emit("loading", this.loading);
    },
    // 日付フォーマット
    formatDate (date) {
      if (!date) return null;
      const [year, month, day] = date.split('-');
      return `${year}/${month}/${day}`;
    },
    parseDate (date) {
      if (!date) return null;
      const [year,month, day] = date.split('/');
      return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`;
    },
    initialize() {
      this.systemNotificationsApi = new SystemNotificationsApi();
      const now = new Date();
      this.scheduledDisplayDateCalendar = now.getFullYear() + "-" + ("00" + (now.getMonth() + 1)).slice(-2) + "-" + ("00" + (now.getDate())).slice(-2);
      this.displayPeriodCalendar = now.getFullYear() + "-" + ("00" + (now.getMonth() + 1)).slice(-2) + "-" + ("00" + (now.getDate())).slice(-2);

    },
    //登録ボタン押下時
    checkDialog() {
      this.dialogTitle = "登録しますか？";
      this.dialogItems = [
        { name: "表示予定日", value: this.inputData.scheduledDisplayDate },
        { name: "表示期限日", value: this.inputData.displayPeriod },
        { name: "タイトル", value: this.inputData.title },
        { name: "お知らせ内容", value: this.inputData.content }
      ];
      this.dialogDrawer = true;
    },
    dialogCancel() {
      this.dialogDrawer = false;
    },
    //ダイアログ登録ボタン押下時 //登録ボタンを押下した場合、notificationsテーブルへレコード登録→システムお知らせ情報画面へ遷移
    submit() {
      if (this.$refs.system_notification_form.validate()) {
        this.isLoading();
        const params = {
          scheduled_display_date: this.inputData.scheduledDisplayDate,
          display_period: this.inputData.displayPeriod,
          title: this.inputData.title,
          content: this.inputData.content,
          category: this.inputData.category,
        };
        const promise = this.systemNotificationsApi.store(params);
        promise.then(response => {
          this.$router.push({ name: 'SystemNotification' });
          this.$emit("success", response.data.message);
        }).catch(error => {
          useAppInsights().trackException({exception: error});
          if (error.response) {
            if (error.response.status == statusList.status.authError) {
              this.dialogDrawer = false;
              this.$emit('logoutConform');
            } else {
              this.$emit("error",error.response.data.message);
            }
          } else {
            this.$emit("error","サーバーエラーが発生しました。");
          }
        }).finally(() => {
          this.isLoading();
        });
      }
    }
  }
};
</script>
